import EditProjectAttribute from "src/components/EditProjectAttribute/EditProjectAttribute";
import { IShowEditProjectAttributeParams } from "src/models";

export default {
    editProjectAttributeComponent: null,

    dispose() {
        if (this.editProjectAttributeComponent) {
            this.editProjectAttributeComponent.dispose();
        }
        this.editProjectAttributeComponent = null;
    },

    show(params: IShowEditProjectAttributeParams) {
        if (!this.editProjectAttributeComponent) {
            this.editProjectAttributeComponent = new EditProjectAttribute({
                source: '<x-edit-project-attribute></x-edit-project-attribute>'
            });
            this.editProjectAttributeComponent.attach(document.body);
        }
        this.editProjectAttributeComponent.show(params)
    }
};